import { v4 as uuidV4 } from 'uuid';

import { PlotterMode } from 'business/data-analysis/constants';
import { ChartType } from 'business/data-analysis/pages/graph/components/chart/types';
import { displayTypes } from 'business/data-analysis/pages/graph/types';
import { GraphSetTypeEnum_Enum } from 'generated/graphql';

import {
  GraphState,
  PeriodParameter,
  GraphPageState,
  RingParameter,
} from './types';

// Period
const initialPeriodGraphSetStructure = {
  title: '',
  type: GraphSetTypeEnum_Enum.Period,
  graphs: new Map<string, GraphState>().set(uuidV4(), {
    title: '',
    displayType: displayTypes.graph,
    chartType: ChartType.LINE,
    parameters: new Map<string, PeriodParameter>(),
    graphNumber: 1,
  }),
};

const initialPeriodGraphSet: GraphPageState = {
  currentGraphId: null,
  displayParameterList: true,
  isLoading: false,
  structure: initialPeriodGraphSetStructure,
  savedState: structuredClone(initialPeriodGraphSetStructure),
} satisfies GraphPageState;

// Ring
const initialRingGraphSetStructure = {
  title: '',
  type: GraphSetTypeEnum_Enum.Ring,
  graphs: new Map<string, GraphState>().set(uuidV4(), {
    title: '',
    displayType: displayTypes.graph,
    chartType: ChartType.BAR,
    parameters: new Map<string, RingParameter>(),
    graphNumber: 1,
  }),
};

const initialRingGraphSet: GraphPageState = {
  currentGraphId: null,
  displayParameterList: true,
  isLoading: false,
  structure: initialRingGraphSetStructure,
  savedState: structuredClone(initialRingGraphSetStructure),
} satisfies GraphPageState;

export const getInitialGraphSetState = (mode: PlotterMode) => {
  if (mode === PlotterMode.TIME_PERIOD) {
    return initialPeriodGraphSet;
  }
  return initialRingGraphSet;
};
